import { useState } from 'react';

import useAppNavigation from '../../hooks/useAppNavigation';
import { useGetGeolocation } from '../../hooks/useGeolocation';
import { NavigateToSearchButton } from '../NavigateToSearchButton';

export default function FindNearMeButton({ title }: { title?: string }) {
  const navigation = useAppNavigation();

  const getGeolocation = useGetGeolocation();
  const [geolocationLoading, setGeolocationLoading] = useState(false);

  const findNearMe = async () => {
    setGeolocationLoading(true);
    let position;
    try {
      position = await getGeolocation();
    } catch {}
    setGeolocationLoading(false);

    navigation.push('Search', {
      lat: position?.coords.latitude.toString(),
      lng: position?.coords.longitude.toString(),
    });
  };

  return (
    <NavigateToSearchButton
      onPress={findNearMe}
      loading={geolocationLoading}
      loadingText="Getting your location"
      title={title}
    />
  );
}
